module.exports = new __parcel__URL__("konsens.b49e7e7e.svg").toString();